const baseUrl = 'https://gravaa.com'; // Base URL of your site
export function useImageUtils() {

  function isMobile() {
    
    if (typeof navigator !== 'undefined') {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|iPad|iPhone|iPod/.test(userAgent.toLowerCase());
    }
    return false;
  }



  const toImgixPath = (image) => {
    try{
      return image.replace('https://cdn.shopify.com/', '').replace(/\?v=\d+/, '');
    }catch (error) {
        console.error('Error converting image path to imgix', error);
        console.log(image);
        return '';
    }
  };

  function extractImageFromPageBody(body) {
    if (body) {
      try {
        const imgTagMatch = body.match(/<img[^>]+src="([^">]+)"/);
        const imageUrl = imgTagMatch ? imgTagMatch[1] : null;
        return toImgixPath(imageUrl);
        
      } catch (error) {
        console.error('Error extracting image from page body', error);
        
        return null;
      }
    } else {
      return null;
    }
  }

  function getOgPageImage(page){
    
    try{
      // Kolla först om page finns
      if (!page) {
        return undefined;
      }
      // Kolla först om vi har en bild-URL alls
      if (!page.coverImage?.reference?.image?.url) {
        // Ingen bild? Returnera t.ex. undefined eller en fallback-URL här.
        return undefined;
      }

      // Om en bild finns:
      const imageUrl = 'https://gravaa-imgix.imgix.net/' + toImgixPath(page.coverImage.reference.image.url);

      // Sätt fokuspunkt till 0.5,0.5 (center) om inget specificerat
      const focalPointX = page.coverImage?.reference?.presentation?.asJson?.focalPoint?.x ?? 0.5;
      const focalPointY = page.coverImage?.reference?.presentation?.asJson?.focalPoint?.y ?? 0.5;

      const width = 1200;
      const ar = '1200:630';

      return `${imageUrl}?ar=${ar}&w=${width}&auto=format,compress&fit=crop&fp-x=${focalPointX}&fp-y=${focalPointY}` + '&page=' + page.handle;
    }catch (error) {
      console.error('getOgPageImage: Error generating Open Graph image URL', error);
      return undefined;
    }
  }

  function getOgProductImage(product){
    
    try{
      // Kolla först om vi har en bild-URL alls
      if (!product.featuredImage) {
        // Ingen bild? Returnera t.ex. undefined eller en fallback-URL här.
        return undefined;
      }

      // Om en bild finns:
      const imageUrl = 'https://gravaa-imgix.imgix.net/' + toImgixPath(product.featuredImage.url);

      const width = 1200;
      const ar = '1200:630';

      return `${imageUrl}?ar=${ar}&w=${width}&auto=format,compress&fit=crop&crop=faces`;

    }catch (error) {
      console.error('Error generating product Open Graph image URL', error);
      return undefined;
    }
  }

  function getOgArticleImage(article){
    
    try{
      // Kolla först om vi har en bild-URL alls
      if (!article.coverImage?.reference?.image?.url) {
        // Ingen bild? Returnera t.ex. undefined eller en fallback-URL här.
        // Om en bild finns:
        const imageUrl = 'https://gravaa-imgix.imgix.net/' + toImgixPath(article.image);
        
        const width = 1200;
        const ar = '1200:630';

        return `${imageUrl}?ar=${ar}&w=${width}&auto=format,compress&fit=crop&crop=faces`;
        
      }

      // Om en bild finns:
      const imageUrl = 'https://gravaa-imgix.imgix.net/' + toImgixPath(article.coverImage.reference.image.url);

      // Sätt fokuspunkt till 0.5,0.5 (center) om inget specificerat
      const focalPointX = article.coverImage?.reference?.presentation?.asJson?.focalPoint?.x ?? 0.5;
      const focalPointY = article.coverImage?.reference?.presentation?.asJson?.focalPoint?.y ?? 0.5;

      const width = 1200;
      const ar = '1200:630';

      return `${imageUrl}?ar=${ar}&w=${width}&auto=format,compress&fit=crop&fp-x=${focalPointX}&fp-y=${focalPointY}`;
    }catch (error) {
      console.error('getOgArticleImage:Error generating Open Graph image URL', error);
      return undefined;
    }
  }

  function getTwitterImage(page){
    // Kolla först om page finns
    if (!page) {
      return undefined;
    }
    // Kolla först om vi har en bild-URL alls
    if (!page.coverImage?.reference?.image?.url) {
      // Ingen bild? Returnera t.ex. undefined eller en fallback-URL här.
      return undefined;
    }
    // Om en bild finns:
    const imageUrl = 'https://gravaa.imags.imgix.net/' + toImgixPath(page.coverImage.reference.image.url);
    // Sätt fokuspunkt till 0.5,0.5 (center) om inget specificerat
    const focalPointX = page.coverImage?.reference?.presentation?.asJson?.focalPoint?.x ?? 0.5;
    const focalPointY = page.coverImage?.reference?.presentation?.asJson?.focalPoint?.y ?? 0.5;
    const width = 1200;
    const ar = '16:9';    

    return `${imageUrl}?ar=${ar}&w=${width}&auto=format,compress&fit=crop&fp-x=${focalPointX}&fp-y=${focalPointY}`;
  }

  function getSeoPageMeta(page) {
    try {
      // Return empty object if page is null/undefined
      if (!page) {
        return {};
      }
      let ogImage = getOgPageImage(page);
      return {
        title: page.seo?.title || page.title,
        ogUrl: page.seo?.url || baseUrl + '/' + page.handle,
        ogTitle: page.seo?.title || page.title,
        description: page.seo?.description || page.bodySummary,
        ogDescription: page.seo?.description || page.bodySummary,
        ogImage: ogImage,
        ogImageheight: 1200,
        ogImagewidth: 630,
        twitterCard: getTwitterImage(page),
        robots: 'index, follow',        
      };
    } catch (error) {
      console.error('Error generating SEO page meta', error);
      return {};
    }
  }

  function getSeoProductMeta(product) {
    try{
      let ogImage = getOgProductImage(product);
      return {
        title: product.seo?.title || product.title,
        ogUrl: product.seo?.url || baseUrl + '/products/' + product.handle,
        ogTitle: product.seo?.title || product.title,
        description: product.seo?.description || product.shortDescription.value,
        ogDescription: product.seo?.description || product.shortDescription.value,
        ogImage: ogImage,
        ogImageheight: 1200,
        ogImagewidth: 630,        
        robots: 'index, follow'
      };
    }catch (error) {
      console.error('Error generating SEO product meta', error);
      return {
       
      };
    }
  }

  function getSeoArticleMeta(article) {
    try{
    let ogImage = getOgArticleImage(article);
    
    return {
      title: article.seo?.title || article.title,      
      ogTitle: article.seo?.title || article.title,
      description: article.seo?.description || article.excerpt,
      ogDescription: article.seo?.description || article.excerpt,
      ogImage: ogImage,
      ogImageheight: 1200,
      ogImagewidth: 630,
            
    };
    }catch (error) {
      console.error('Error generating getSeoArticleMeta', error);
      console.error('Article:', article.handle);
      return {
       title: 'Gravaa Article',
      };
    }

  }

  function getSeoBlogMeta(blog) {
    try{
    let ogImage = getOgArticleImage(blog.articles[0]);
    
    return {
      title: blog.seo?.title || blog.title,
      ogTitle: blog.seo?.title || blog.title,
      description: blog.seo?.description || '',
      ogDescription: blog.seo?.description || '',
      ogImage: ogImage,
      ogImageheight: 1200,
      ogImagewidth: 630,
            
    };
    }catch (error) {
      console.error('Error generating getSeoBlogMeta', error);
      console.error('Blog:', blog.handle);
      return {
       title: 'Gravaa Journal',
      };
    }

  }

  return {
    isMobile,
    toImgixPath,
    extractImageFromPageBody,    
    getTwitterImage,
    getSeoPageMeta,
    getSeoProductMeta,
    getSeoArticleMeta,
    getSeoBlogMeta,
    getOgArticleImage

  };
}